module.exports = __webpack_public_path__ + "img/step_bar_01.43ae5243.png";